var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppTooltip',{attrs:{"position":"bottom","text":'Extension needed'}},[_c('SIcon',{attrs:{"name":'puzzle-outline',"width":"15","height":"15"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }